import { SequenceType } from './types';
import * as React from 'react';

type SequenceTypeSetter = (test: SequenceType) => void;
type SequenceTypeContextValues = [SequenceType, SequenceTypeSetter];

const SelectedSequenceTypeContext =
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  React.createContext<SequenceTypeContextValues>(null);

/**
 * @description A hook for reading and setting the selected sequence type prop.
 * This is used throughout the OE to determine if we are viewing somatic or
 * germline data.
 */
function useSelectedSequenceType() {
  const context = React.useContext(SelectedSequenceTypeContext);

  if (!context) {
    throw new Error(
      'useSelectedSequenceType must be used within a SelectedSequenceTypeProvider',
    );
  }

  return context;
}

function SelectedSequenceTypeProvider(props: any) {
  const [selectedSequenceType, setSelectedSequenceType] =
    React.useState<SequenceType>('somatic');

  const value = React.useMemo(
    () => [selectedSequenceType, setSelectedSequenceType],
    [selectedSequenceType],
  );

  return <SelectedSequenceTypeContext.Provider value={value} {...props} />;
}

export { SelectedSequenceTypeProvider, useSelectedSequenceType };
